export default function Footer() {
  const footerLinks = [
    {
      title: '热门综艺',
      links: ['奔跑吧', '极限挑战', '乘风2024', '王牌对王牌', '向往的生活'],
    },
    {
      title: '快速入口',
      links: ['焦点专题', '精彩片段', '热门榜单', '最新更新', '主题索引'],
    },
    {
      title: '关于平台',
      links: ['关于我们', '常见问答', '联系我们', '用户协议', '隐私政策'],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto py-14 md:py-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="inline-block mb-4">
                <span className="text-2xl font-black tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                  <span className="text-primary-400">51</span>
                  <span className="text-white">影视</span>
                </span>
              </a>
              <p className="text-foreground-400 text-sm leading-relaxed mb-6">
                51影视网提供综艺节目免费在线观看，最新热门综艺高清不缓冲，全集免费看。涵盖户外真人秀、音乐竞演、脱口秀等全品类综艺内容，每日同步更新。
              </p>
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/70 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/70 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/70 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-vidicon-line text-lg"></i>
                </span>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h3 className="text-white font-semibold text-sm mb-5 whitespace-nowrap">{group.title}</h3>
                {group.links.length > 0 ? (
                  <ul className="space-y-3">
                    {group.links.map((link) => (
                      <li key={link}>
                        <a
                          href={`#${link}`}
                          className="text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-foreground-500 text-sm">敬请期待</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs md:text-sm">
              &copy; {new Date().getFullYear()} 51影视网 版权所有 | 综艺节目免费在线观看平台
            </p>
            <p className="text-foreground-600 text-xs">
              本站内容仅供学习交流，请支持正版
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}